<template>
    <div>
        <b-alert show variant="warning">
            {{
                $t(
                    "Live streaming is only supported from the browser, please open the app in your web browser to continue"
                )
            }}

            <div class="mt-3">
                <font-awesome-icon icon="fa-duotone fa-info-circle" />
                {{
                    $t(
                        "The livestream will not begin until you join the livestream on your browser"
                    )
                }}
            </div>

            <div class="text-center branded py-3">
                <font-awesome-icon icon="fa-light fa-arrow-down" size="2x" />
            </div>

            <b-btn
                v-if="url"
                @click="openBrowser"
                variant="primary"
                size="lg"
                pill
                block
            >
                <font-awesome-icon
                    icon="fa-duotone fa-arrow-up-right-from-square"
                />
                {{ $t("Open in Browser") }}
            </b-btn>

            <div class="mt-3">
                <b-btn
                    v-if="url"
                    @click="copyUrl"
                    variant="link"
                    size="sm"
                    pill
                    block
                >
                    {{ $t("Copy Livestream URL") }}
                </b-btn>
            </div>
        </b-alert>
    </div>
</template>



<script>
import { mapState } from "vuex";

import copy from "clipboard-copy";

export default {
    data() {
        return {
            url: null,
        };
    },
    mounted() {
        const id = this.$route.params?.id;

        this.api.post(`/creatorLivestream/${id}/url`).then((response) => {
            if (response?.data?.url) {
                this.url = response?.data?.url;
            }
        });
    },
    computed: {
        ...mapState("creatorLivestream", ["creatorLivestream"]),
    },
    methods: {
        openBrowser() {
            this.$store.dispatch("system/openBrowser", this.url);
        },
        copyUrl() {
            copy(this.url);
        },
    },
};
</script>